import { useState } from "react";
import { ListQuery } from "../Types/CommonTypes";

const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes

const useCachedListQuery = (defaultQuery: ListQuery, key?: string, skipCache?: boolean) => {
    const storageKey = key ?? `${window.location.pathname}_query`;

    const getInitialQuery = (): ListQuery => {
        try {
            const cached = localStorage.getItem(storageKey);
            if (!skipCache && cached) {
                const { timestamp, value } = JSON.parse(cached);
                if (Date.now() - timestamp < CACHE_DURATION) {
                    return value as ListQuery;
                }
            }
        } catch {
            // ignore malformed cache
        }
        localStorage.removeItem(storageKey);
        return defaultQuery;
    };

    const [query, setQueryState] = useState<ListQuery>(getInitialQuery);

    const setQuery = (q: ListQuery) => {
        setQueryState(q);
        try {
            localStorage.setItem(
                storageKey,
                JSON.stringify({ timestamp: Date.now(), value: q })
            );
        } catch {
            // ignore write errors
        }
    };

    return [query, setQuery] as const;
};

export default useCachedListQuery;
